"use strict";

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function SvgShGender(props) {
  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 18 15.578" }, props),
    React.createElement("path", { d: "M17.625 0h-2.469a.365.365 0 00-.266.624l.528.514L13.9 2.62a4.6 4.6 0 00-5.184.268 5.336 5.336 0 011 1.737 2.523 2.523 0 011.784-.73A2.471 2.471 0 0114 6.329a2.471 2.471 0 01-2.5 2.434 2.528 2.528 0 01-1.784-.73 5.281 5.281 0 01-1 1.737 4.55 4.55 0 002.788.94A4.443 4.443 0 0016 6.329a4.276 4.276 0 00-.691-2.334l1.522-1.482.528.514A.378.378 0 0018 2.769V.365A.371.371 0 0017.625 0zM4.5 1.947A4.443 4.443 0 000 6.329 4.41 4.41 0 003.5 10.6v1.57H2.375a.371.371 0 00-.375.366v1.217a.371.371 0 00.375.365H3.5v1.1a.371.371 0 00.375.365h1.25a.371.371 0 00.375-.365v-1.1h1.125A.371.371 0 007 13.753v-1.217a.371.371 0 00-.375-.365H5.5V10.6A4.412 4.412 0 009 6.329a4.443 4.443 0 00-4.5-4.382zm0 6.816A2.471 2.471 0 012 6.329a2.471 2.471 0 012.5-2.434A2.471 2.471 0 017 6.329a2.471 2.471 0 01-2.5 2.434z" })
  );
}

exports.default = SvgShGender;
module.exports = exports["default"];